"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LoyaltyDialogControllerProps = require("./LoyaltyDialogControllerProps");
Object.keys(_LoyaltyDialogControllerProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoyaltyDialogControllerProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoyaltyDialogControllerProps[key];
    }
  });
});
